import styled from 'styled-components'

const Container = styled.header`
    background: #006897;
    color: #FFFFFF;
`

export {
    Container
}